var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19884",
    "data-name": "Group 19884",
    transform: "translate(-298 -96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bar1",
    "data-name": "Rectangle 19297",
    width: 20,
    height: 2,
    transform: "translate(298 96)",
    fill: "#002c5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bar2",
    "data-name": "Rectangle 19298",
    width: 14,
    height: 2,
    transform: "translate(301 102)",
    fill: "#002c5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "bar3",
    "data-name": "Rectangle 19299",
    width: 20,
    height: 2,
    transform: "translate(298 108)",
    fill: "#002c5f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/Burger.6695b3c9a939d7950e494706a65e9bec.svg";
export { ForwardRef as ReactComponent };